import { render } from "./AppTour.vue?vue&type=template&id=47d4bd09&ts=true"
import script from "./AppTour.vue?vue&type=script&lang=ts"
export * from "./AppTour.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__